import styles from './style.module.css';

const Spinner = ({ large }) => (
  <div className={[styles.lds__spinner, large ? styles.large__spinner : ''].join(' ')}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
);

export default Spinner;
